<template>
    <nomad-operator-chat
        v-if="isWebComponentReady"
        ref="chatOperatorRef"
        :class="[isPayerChatOpen && 'new-chat__open']"
    >
    </nomad-operator-chat>
</template>

<script>
import {mapActions, mapMutations} from "vuex";
import Cookies from "js-cookie";
import { getEnvironmentByOrigin } from '@/utils/getEnvironment'
import {OPERATOR_CHAT_TOKEN} from "@/consts/operatorChat";

export default {
    data() {
        return {
            isWebComponentReady: false,
            elementsClassesToHideList: [
                'header-lk',
                'grecaptcha-badge',
                'ws-chat',
                'tab-content',
                'fixed-mob-button',
            ],
            elementsClassesToFixPositionList: [
                'ws-chat',
            ],
        };
    },
    computed: {
        isPayerChatOpen() {
            return this.$store.state.payerChat.isPayerChatOpen;
        },
        locale() {
            return this.$i18n.locale
        },
        user() {
            return this.$store.state.auth.user
        },
        token() {
            return this.$store.state.auth.chatOperatorToken;
        }
    },
    watch: {
        isPayerChatOpen: {
            immediate: true,
            handler (newVal) {
                newVal ? this.openChatModal() : this.closeChatModal
            }
        },
        locale: {
            immediate: true,
            handler (newVal) {
                this.$refs.chatOperatorRef?.setAttribute("locale", newVal.toLowerCase());
            }
        },
        token: {
            immediate: true,
            handler (newVal) {
               this.updateToken(newVal)
            }
        }
    },
    methods: {
        ...mapActions("payerChat", ["closePayerChatModal"]),
        ...mapMutations("payerChat", ["SET_UNREAD_OPERATOR_MESSAGES_COUNT"]),
        ...mapMutations("auth", ["SET_CHAT_OPERATOR_TOKEN"]),
        openChatModal() {
              this.setToken()
              this.$refs.chatOperatorRef?.setAttribute("is-open", 'open');
              this.updateLocale()
              this.$refs.chatOperatorRef?.addEventListener("chat-close", this.closeChatModal);
              this.hideNonChatElements();
            },
        setEnvironment() {
/*
            const currentEnvironment = process.env.NODE_ENV ?? 'production';
*/ // TODO необходимо понять, почему при билде deploy_dev скриптом у них идет building for production, и убрать заплатку ниже

            this.$refs.chatOperatorRef?.setAttribute("environment", getEnvironmentByOrigin());
        },
        closeChatModal() {
            this.$refs.chatOperatorRef?.setAttribute("is-open", '');
            this.$refs.chatOperatorRef?.removeEventListener("chat-close", this.closeChatModal)
            this.closePayerChatModal();
            this.showNonChatElements();
        },
        hideNonChatElements() {
            document.documentElement.classList.add('hide-elements-under-new-chat')
        },
        showNonChatElements() {
            document.documentElement.classList.remove('hide-elements-under-new-chat')
        },
        updateLocale() {
            this.$refs.chatOperatorRef?.setAttribute("locale", this.$i18n.locale)
        },
        setToken() {
            const token = Cookies.get(OPERATOR_CHAT_TOKEN)
            this.$refs.chatOperatorRef?.setAttribute("token", token ?? '')
            this.SET_CHAT_OPERATOR_TOKEN(token ?? '')
        },
        updateUnreadCounter(event) {
            this.SET_UNREAD_OPERATOR_MESSAGES_COUNT(Number(event.detail) ?? 0)
        },
        updateToken(event) {
            this.$refs.chatOperatorRef?.setAttribute("token", event ?? '')
        },
        onRefreshToken(event) {
            Cookies.set(OPERATOR_CHAT_TOKEN, event.detail, {expires: 365})
            this.SET_CHAT_OPERATOR_TOKEN(event.detail)
        },
      },
    mounted() {
        this.isWebComponentReady = true;
        this.$nextTick(() => {
            this.setEnvironment()
            this.setToken()
            this.$refs.chatOperatorRef?.addEventListener("update-unread", this.updateUnreadCounter);
            this.$refs.chatOperatorRef?.addEventListener("update-token", this.onRefreshToken);
        })
    },
    beforeDestroy() {
        this.$refs.chatOperatorRef?.removeEventListener("update-unread", this.updateUnreadCounter);
        this.$refs.chatOperatorRef?.removeEventListener("chat-close", this.closeChatModal);
        this.$refs.chatOperatorRef?.removeEventListener("update-token", this.onRefreshToken);
    }
};
</script>
